<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line"
              >
                <Validate name="Kode Sekolah" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Kode"
                    label="Kode"
                    :error-messages="errors"
                    placeholder="Kode Sekolah"
                    v-model="form.Kode"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Nama Sekolah" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Nama"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama Sekolah"
                    v-model="form.Nama"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Tipe Sekolah" rules="required" #default="{ errors }">
                  <v-select
                    class="mb-3"
                    :items="list.tipeSekolah.data"
                    name="Tipe"
                    label="Tipe"
                    :error-messages="errors"
                    placeholder="Tipe Sekolah"
                    v-model="form.TipeSekolah"
                    :return-object="false"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-select>
                </Validate>
                <Validate name="Nama Bidang" rules="required" #default="{ errors }">
                  <v-autocomplete
                    class="mb-3"
                    :items="list.bidang.data"
                    item-text="Nama"
                    item-value="IDBidang"
                    name="Bidang"
                    label="Bidang"
                    :error-messages="errors"
                    placeholder="Nama Bidang"
                    v-model="form.IDBidang"
                    :return-object="false"
                    hide-details="auto"
                    outlined
                    dense
                  >
                    <template v-slot:selection="data">
                      <div class="text--secondary caption mb-n2 mt-2">{{data.item.Kode}}</div>
                      <v-list-item-title>{{data.item.Nama}}</v-list-item-title>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title class="py-0">
                            {{data.item.Nama}}
                            &mdash;
                            <span
                              class="text--secondary"
                            >{{data.item.Kode}}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </Validate>
                <!-- <Validate name="Nama Rekening" rules="required" #default="{ errors }">
                  <v-autocomplete
                    class="mb-3"
                    :items="list.rekening.data"
                    item-text="Nama"
                    item-value="IDRekening"
                    name="Rekening"
                    label="Rekening"
                    :error-messages="errors"
                    placeholder="Nama Rekening"
                    v-model="form.IDRekening"
                    :return-object="false"
                    hide-details="auto"
                    outlined
                    dense
                  ></v-autocomplete>
                </Validate>-->
                <Validate name="NPWP" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="NPWP"
                    label="NPWP"
                    :error-messages="errors"
                    placeholder="NPWP"
                    v-model="form.NPWP"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Singkatan" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Singkatan"
                    label="Singkatan"
                    :error-messages="errors"
                    placeholder="Singkatan"
                    v-model="form.Singkatan"
                    hide-details="auto"
                    hint="Singkatan digunakan untuk pembuatan nomor"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1 mt-n9 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-0">
              <div class="headline v-hidden hidden-sm-and-down">{{title()}}</div>
              <br />
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Kelurahan" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Kelurahan"
                    label="Kelurahan"
                    :error-messages="errors"
                    placeholder="Kelurahan"
                    v-model="form.Desa"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Kota" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Kota"
                    label="Kota"
                    :error-messages="errors"
                    placeholder="Kota"
                    v-model="form.Provinsi"
                    hide-details="autp"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <!-- <Validate name="Lokasi" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Lokasi"
                    label="Lokasi"
                    :error-messages="errors"
                    placeholder="Lokasi"
                    v-model="form.Lokasi"
                    hide-details="Lokasi"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>-->
                <Validate name="Alamat" rules="required" #default="{ errors }">
                  <v-textarea
                    class="mb-3"
                    name="Alamat"
                    label="Alamat"
                    :error-messages="errors"
                    placeholder="Alamat"
                    v-model="form.Alamat"
                    hide-details="Alamat"
                    outlined
                    required
                    dense
                  ></v-textarea>
                </Validate>
                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Kode: "",
      Nama: "",
      TipeSekolah: "",
      IDBidang: "",
      IDRekening: "",
      NPWP: "",
      Singkatan: "",
      Desa: "",
      Provinsi: "",
      Alamat: "",
      Lokasi: ""
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isBidangLoading", "isRekeningLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/administration/sekolah", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/sekolah");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Sekolah" : "Sekolah Baru";
    },

    ...mapActions("list", ["refreshBidang", "refreshRekening"])
  },
  async mounted() {
    this.refreshBidang();
    // this.refreshRekening();
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/administration/sekolah/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>